module.exports = __webpack_public_path__ + "img/card1.63e556b9.png";